import "./Tree.scss";

import { CollapseTransition } from "@ivanv/vue-collapse-transition";
import { baseUrl } from "../../../config.js";
import draggable from "vuedraggable";
import { EventBus } from "../../../eventbus.js";
import { userHasAllRights } from "../../../functions/userRights.js";

export default {
  components: {
    CollapseTransition,
    draggable,
  },
  props: ["tree", "mySpace", "id", "item"],
  data() {
    return {
      user: this.$store.state.user,
      company: this.$store.state.company,
      isDragging: false,
    };
  },
  created() {
    EventBus.$on("tree-overview--dragging", (data) => {
      this.isDragging = data.isDragging;
    });
  },
  methods: {
    canMoveFolders() {
      return userHasAllRights(["move_folders"], this);
    },
    getComponentData() {
      return {
        attrs: {
          "data-id": this.id,
        },
        props: {
          item: this.item,
        },
      };
    },
    startDraging(e) {
      EventBus.$emit("tree-overview--dragging", {
        isDragging: true,
      });
    },
    endDraging(e) {
      const toMoveFolder = e.item.dataset.id;
      const target = e.to.dataset.id;

      EventBus.$emit("tree-overview--dragging", {
        isDragging: false,
      });

      if (toMoveFolder !== target) {
        //move folder to new location

        const formData = new FormData();
        formData.append("myspace", this.mySpace);
        formData.append("parent", target);
        formData.append("folders", [toMoveFolder]);
        formData.append("files", []);

        if (target === "myspace") {
          formData.set("parent", null);
        }

        this.$axios
          .post(baseUrl + "/changeparentmultiple", formData)
          .then((r) => {
            //refresh the file holder
            EventBus.$emit(`desktop-files-update`);
          });
      }
    },
    handleToggleExpand(e, key) {
      e.preventDefault();

      this.toggleChild(key);
    },
    toggleChild(key) {
      const newChild = this.tree[key];

      newChild.expanded = !newChild.expanded;

      //close all children if present
      if (newChild.nodes) {
        newChild.nodes = newChild.nodes.map((node) => {
          return { ...node, expanded: false };
        });
      }

      this.tree[key] = newChild;
    },
    expandActive() {
      //if active folder is presend expand that item
      if (this.tree) {
        this.tree.forEach((node) => {
          if (node.id === this.$route.params.id) {
            node.expanded = true;
          }
        });
      }
    },
  },
  watch: {
    $route() {
      this.expandActive();
    },
  },
};
